<template>
  <div class="emb-blogDetail-wrap" v-if="blogDetails != null">
    <div
      class="blog-img-wrapper relative"
      :style="{'background-image': ' url('+ blogDetails.Detail_Image_Image_1920_x_800px+ ')'}"
    >
      <div class="center-holder">
        <div class="container">
          <v-layout row wrap align-center justify-center ma-0>
            <v-flex sm12 xs12 md8 lg7 xl7 pa-0>
              <h5 class="mb-6">
                <i class="material-icons">trending_up</i>
                {{MainContent.Featured_Post_Label}}
              </h5>
              <h2 class="mb-6">{{blogDetails.Title}}</h2>
              <div class="blog-meta mb-4">
                <a class="mr-4" href="javascript:void(0);">
                  <i class="material-icons">account_circle</i>
                  <span class="font-weight-regular">{{blogDetails.Author_Name}}</span>
                </a>
                <a href="javascript:void(0);">
                  <i class="material-icons">date_range</i>
                  <span class="font-weight-regular">{{dateFormat(blogDetails.Date)}}</span>
                </a>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
    <div class="inner-container bg-white">
      <v-container grid-list-xl pb-0>
        <div class="blog-detail section-gap">
          <v-layout row wrap align-center justify-center>
            <v-flex xs12 sm12 md10 lg7 xl7>
              <div class="blog-content mb-12" v-html="blogDetails.Description"></div>
              <!-- <div class="tags-social-block mb-6">
								<div class="d-sm-flex align-center justify-space-between">
									<div class="mb-sm-0 mb-6">
										<v-chip color="accent" text-color="white">
											Shopping
										</v-chip>
										<v-chip color="accent" text-color="white">
											Online
										</v-chip>
									</div>
									<div>
										<emb-social-share></emb-social-share>
									</div>
								</div>
              </div>-->
              <!-- <div class="blog-links  grey lighten-3 pa-6">
								<div class="d-flex align-center justify-space-between " >
									<div class="previous-blog">
										<v-btn class="accent">Prev</v-btn>
									</div>
									<div class="next-blog ">
										<v-btn class="accent">Next</v-btn>
									</div>
								</div>
              </div>-->
              <div class="author-section pt-6 pb-2">
                <div class="sec-title">
                  <h3 class="mb-0">{{MainContent.About_The_Author_Label}}</h3>
                </div>
                <v-layout row wrap align-center v-if="blogDetails != null">
                  <v-flex sm3 md2 lg2 xl2 mb-3>
                    <img
                      class="br-100"
                      alt="author detail"
                      :src="blogDetails.Author_Image_200_x_200px"
                      width="200"
                      height="200"
                    />
                  </v-flex>
                  <v-flex sm9 md8 lg10 xl10 mb-3>
                    <h4>{{blogDetails.Author_Name}}</h4>
                    <p v-html="blogDetails.Author_Description"></p>
                  </v-flex>
                </v-layout>
                <v-divider class="my-6"></v-divider>
              </div>
              <div class="blog-comment-section mb-2">
                <div class="sec-title">
                  <h3 class="mb-0" v-if="!Commentscount">{{MainContent.No_Comments_Label}}</h3>
                  <h3 v-else class="mb-0">{{MainContent.Comments_Label}}({{Commentscount}})</h3>
                </div>
                <!-- <ul class="comment-list"> -->
                <ul class="comment-list">
                  <template v-for="(comments,key) in CommentsList">
                    <li
                      :key="key"
                      class="layout comment-item row wrap align-center justify-between"
                    >
                      <v-flex sm2 md2 lg2 xl2>
                        <img
                          class="br-50"
                          src="\static\images\user.svg"
                          alt="user"
                          width="100"
                          height="100"
                        />
                      </v-flex>
                      <v-flex sm10 md10 lg10 xl10>
                        <h5>{{comments.keyword1}}</h5>
                        <p>{{comments.text1}}</p>
                        <div class="d-flex justify-space-between">
                          <!-- <div>
														<a href="javascript:void(0)" class="primary--text font-weight-bold">Reply</a>
                          </div>-->
                          <div
                            class="primary--text font-weight-bold comment-date"
                          >{{dateFormat(comments.date1)}}</div>
                        </div>
                      </v-flex>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="leave-commet pt-6">
                <div class="sec-title mb-6">
                  <h3 class="mb-0">{{MainContent.Leave_Comments_Label}}</h3>
                </div>
                <v-layout row wrap>
                  <v-flex sm12 md12 lg12 xl12 py-0>
                    <v-text-field
                      type="text"
                      class="mt-0"
                      :placeholder="MainContent.Title_Placeholder"
                      v-model="Title"
                    ></v-text-field>
                    <!-- <v-text-field type='text' placeholder="Last Name"></v-text-field>
                    <v-text-field type='email' placeholder="Email"></v-text-field>-->
                    <v-textarea
                      :placeholder="MainContent.Message_Placeholder"
                      rows="2"
                      v-model="comment"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <v-btn
                  class="accent mt-6 mx-0"
                  large
                  @click="addCommentBlog()"
                >{{MainContent.Button_Label}}</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import CommentsList from "Assets/data/comments";
import Vue from "vue";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});
export default {
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getBlog();
    this.getPageData();
    // if (this.blogData.length > 0) {
    //   for (var i = 0; i < this.blogData.length; i++) {
    //     if (this.$route.params.id == this.blogData[i].id) {
    //       this.selectedBlog = this.blogData[i];
    //     }
    //   }
    // }
  },
  //   computed: {
  //     ...mapGetters(["blogData"])
  //   },
  data() {
    return {
      //   CommentsList,
      //   selectedBlog: null,
      cmsRequestFunctions: null,
      blogDetails: {},
      Title: "",
      comment: "",
      blogid: "",
      CommentsList: [],
      Commentscount: "",
      MainContent: {},
    };
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
      this.getBlog();
    },
  },
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },
  methods: {
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "23 Blog Details/23 Blog Details/23 Blog Details.ftl",
        lang: language,
        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var Main = self.cmsRequestFunctions.pluck(
              "Main_Content",
              res.area_List
            );
            self.MainContent = self.cmsRequestFunctions.getAllMapData(
              Main[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getBlog: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      //   var packageurl = this.cmsRequestFunctions.getQueryStringValue("page");
      var packageurl = this.$route.query.page;
      if (packageurl != "") {
        self.blogid = packageurl;
        packageurl = packageurl.split("-").join(" ");
        packageurl = packageurl.split("_")[0];
        var url = packageurl + ".ftl";

        var config = {
          pageType: "Template/",
          pageUrl: url,
          lang: language,

          successCallback: function (response) {
            var blogData = response.data;
            if (blogData != undefined && blogData.area_List) {
              var blogD = self.cmsRequestFunctions.pluck(
                "Blog_Content",
                blogData.area_List
              );
              self.blogDetails = self.cmsRequestFunctions.getAllMapData(
                blogD[0].component
              );
            }
          },
          errorCallback: function (error) {
            console.log(error);
          },
        };
        this.cmsRequestFunctions.cmsRequest(config);
        this.readCommentBlog();
      }
    },
    addCommentBlog: async function () {
      var self = this;
      if (self.checkSignInOrNot()) {
        if (!self.Title) {
          this.$snotify.warning(
            self.cmsRequestFunctions.getValidationMsgByCode("M002"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          return false;
        } else if (!self.comment) {
          this.$snotify.warning(
            self.cmsRequestFunctions.getValidationMsgByCode("M032"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          return false;
        } else {
          var user = localStorage.getItem("embryo");
          var userData = JSON.parse(user);
          var loginDetails = userData.user_data;
          let requestedDate = moment(String(new Date())).format(
            "YYYY-MM-DDThh:mm:ss"
          );
          let insertBlogData = {
            type: "Blog Comments",
            text2: self.blogDetails.Title,
            keyword1: loginDetails.name,
            keyword2: loginDetails.email,
            keyword3: loginDetails.loginId,
            text1: self.comment,
            date1: requestedDate,
            keyword4: self.blogid,
            keyword5: self.Title,
          };
          var commentSuccess = await this.cmsRequestFunctions.cmsFormData(
            insertBlogData
          );
          try {
            let insertID = await commentSuccess;
            console.log(insertID);
            self.comment = "";
            self.Title = "";
            this.$snotify.success(
              self.cmsRequestFunctions.getValidationMsgByCode("M016"),
              {
                closeOnClick: false,
                pauseOnHover: false,
                timeout: 1000,
                showProgressBar: false,
              }
            );
            setTimeout(function () {
              self.readCommentBlog();
            }, 3000);
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    readCommentBlog: async function () {
      var self = this;
      self.CommentsList = [];
      var filterValue =
        "type='Blog Comments' AND keyword4='" + self.blogid + "'";
      var allData = await this.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        self.CommentsList = allData.data.data;
      } else {
        console.log("error:", allData);
      }
      self.Commentscount = self.CommentsList.length;
    },
    dateFormat(date) {
      if (date) {
        return moment(String(date)).format("DD MMM YYYY");
      }
    },
    checkSignInOrNot() {
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
